<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>

<form class="admin-forms" [formGroup]="invoiceForm">
  <div class="accordion-class">
    <h5>Generate Invoice</h5>
    <mat-divider></mat-divider>
  </div>

  <div class="input-fileds-container">
    <!-- Customer and Invoice Details Section -->
    <div class="group driver-truck">
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Customer Name <span class="required">*</span></mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="customer_name" placeholder="Select or add customer" />
            <input type="hidden" formControlName="customer_id" />
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Invoice# <span class="required">*</span></mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="invoice_number" />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Order Number</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="reference_number" placeholder="Optional" />
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Invoice Date <span class="required">*</span></mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput type="date" formControlName="date" />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Payment Terms <span class="required">*</span></mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-select formControlName="payment_terms" (selectionChange)="onPaymentTermsChange($event)">
              <mat-option *ngFor="let term of paymentTermsOptions" [value]="term.value">
                {{ term.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Due Date <span class="required">*</span></mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput type="date" formControlName="due_date" />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Accounts Receivable</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-select formControlName="account_id">
              <mat-option *ngFor="let account of accountOptions" [value]="account.value">
                {{ account.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Salesperson</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="salesperson" placeholder="Select salesperson" />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Subject</mat-label>
        </div>
        <div class="col-md-9">
          <mat-form-field>
            <input matInput formControlName="subject_content" placeholder="Enter subject" />
          </mat-form-field>
        </div>
      </div>

      <!-- <mat-divider class="divider_mat"></mat-divider> -->
      <!-- <div class="row mtb align-items-center">
        <div class="col-md-12">
          <h6>Item Table</h6>
        </div>
      </div> -->


    </div>

    <!-- <mat-divider class="divider_mat"></mat-divider> -->
    <!-- Line Items Section -->
    <div class="accordion-class-two">
      <h6>Item Table</h6>
      <mat-divider></mat-divider>
    </div>

    <div class="group driver-truck">
      <div class="">
        <table class="line-items-table">
          <thead>
            <tr>
              <th style="width: 50px;"></th>
              <th>Item Details</th>
              <th style="width: 80px;">Quantity</th>
              <th style="width: 120px;">Rate</th>
              <th style="width: 150px;">Tax</th>
              <!-- <th style="width: 100px;">Discount</th> -->
              <th style="width: 120px;">Amount</th>
              <th style="width: 50px;"></th>
            </tr>
          </thead>
          <tbody formArrayName="line_items">
            <tr *ngFor="let item of lineItems.controls; let i = index" [formGroupName]="i">
              <td class="drag-handle">
                <div class="drag-controls">
                  <button 
                    type="button" 
                    class="btn-icon-sm" 
                    (click)="moveItemUp(i)"
                    [disabled]="i === 0"
                  >
                    ↑
                  </button>
                  <button 
                    type="button" 
                    class="btn-icon-sm" 
                    (click)="moveItemDown(i)"
                    [disabled]="i === lineItems.length - 1"
                  >
                    ↓
                  </button>
                </div>
              </td>
              <td>
                <mat-form-field class="full-width">
                  <textarea 
                    matInput 
                    formControlName="description"
                    placeholder="Item description"
                    rows="1"
                  ></textarea>
                </mat-form-field>
                <mat-form-field class="full-width mt-small">
                  <input matInput formControlName="hsn_or_sac" placeholder="HSN/SAC" />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field class="full-width">
                  <input 
                    matInput 
                    type="number" 
                    formControlName="quantity"
                    step="0.01"
                  />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field class="full-width">
                  <input 
                    matInput 
                    type="number" 
                    formControlName="rate"
                    step="0.01"
                  />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field class="full-width">
                  <mat-select formControlName="tax_id">
                    <mat-option *ngFor="let tax of taxOptions" [value]="tax.value">
                      {{ tax.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <!-- <td>
                <mat-form-field class="full-width">
                  <input 
                    matInput 
                    formControlName="discount"
                    placeholder="% or amt"
                  />
                </mat-form-field>
              </td> -->
              <td class="amount-cell">
                ₹ {{ calculateLineItemAmount(item.value) | number:'1.2-2' }}
              </td>
              <td>
                <button 
                  type="button" 
                  class="btn-delete-sm" 
                  (click)="removeLineItem(i)"
                  [disabled]="lineItems.length === 1"
                >
                  ×
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button type="button" class="btn-add-line" (click)="addLineItem()">
        + Add another line
      </button>
    </div>

    <!-- Totals Section -->
    <div class="group totals-grid">
      <div class="row">
        <!-- <div class="col-md-6">
          <div class="notes-section">
            <mat-label>Customer Notes</mat-label>
            <mat-form-field class="full-width">
              <textarea 
                matInput 
                formControlName="notes"
                rows="3"
              ></textarea>
            </mat-form-field>
            <small class="form-hint">Will be displayed on the invoice</small>
          </div>
        </div> -->
        <div class="col-md-6">
          <div class="totals-box">
            <!-- Sub Total -->
            <div class="total-row">
              <span class="total-label">Sub Total</span>
              <span class="total-value">₹ {{ totals.subTotal }}</span>
            </div>

            <!-- Discount -->
            <div class="total-row discount-row">
              <span class="total-label">Discount</span>
              <div class="discount-inputs">
                <mat-form-field class="discount-amount">
                  <input 
                    matInput 
                    type="number" 
                    formControlName="discount"
                    step="0.01"
                  />
                </mat-form-field>
                <mat-form-field class="discount-type">
                  <mat-select formControlName="discount_type">
                    <mat-option value="percent">%</mat-option>
                    <mat-option value="amount">₹</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <span class="total-value">₹ {{ totals.discountAmount }}</span>
            </div>

            <!-- TDS/TCS and Tax Selection -->
            <div class="total-row tds-tcs-row">
              <div class="tds-tcs-inputs">
                <div class="radio-group">
                  <mat-radio-group formControlName="tax_type">
                    <mat-radio-button value="tds">TDS</mat-radio-button>
                    <mat-radio-button value="tcs">TCS</mat-radio-button>
                  </mat-radio-group>
                </div>
                <mat-form-field class="tax-select">
                  <mat-select formControlName="tax_id" placeholder="Select a Tax">
                    <mat-option *ngFor="let tax of taxOptions" [value]="tax.value">
                      {{ tax.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <span class="total-value">₹ {{ totals.taxAmount || "0.00"}}</span>
            </div>

            <!-- Adjustment -->
            <div class="total-row adjustment-row">
              <span class="total-label">Adjustment</span>
              <div class="adjustment-input">
                <mat-form-field class="adjustment-field">
                  <input 
                    matInput 
                    type="number" 
                    formControlName="adjustment"
                    step="0.01"
                    placeholder="+ / - Adjustment"
                  />
                </mat-form-field>
                <mat-icon class="info-icon" matTooltip="Enter positive or negative adjustment">help_outline</mat-icon>
              </div>
              <span class="total-value">₹ {{ totals.adjustmentAmount }}</span>
            </div>

            <!-- Final Total -->
            <div class="total-row total-final">
              <span class="total-label">Total ( ₹ )</span>
              <span class="total-value">₹ {{ totals.total }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms & Conditions -->
    <div class="group">
      <div class="row mtb align-items-start">
        <div class="col-md-3">
          <mat-label>Terms & Conditions</mat-label>
        </div>
        <div class="col-md-9">
          <mat-form-field class="full-width">
            <textarea 
              matInput 
              formControlName="terms"
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Additional Details (Collapsible) -->
    <!-- <div class="accordion-class-two">
      <details>
        <summary><h5>Additional Details</h5></summary>
        <mat-divider></mat-divider>
        <div class="group additional-details-content">
          <div class="row mtb align-items-center">
            <div class="col-md-3">
              <mat-label>GST Treatment</mat-label>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-select formControlName="gst_treatment">
                  <mat-option *ngFor="let gst of gstTreatmentOptions" [value]="gst.value">
                    {{ gst.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-label>Place of Supply</mat-label>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-select formControlName="place_of_supply">
                  <mat-option *ngFor="let place of placeOfSupplyOptions" [value]="place.value">
                    {{ place.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row mtb align-items-center">
            <div class="col-md-3">
              <mat-label>GST Number</mat-label>
            </div>
            <div class="col-md-9">
              <mat-form-field>
                <input matInput formControlName="gst_no" placeholder="Enter GST number if applicable" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </details>
    </div> -->
  </div>

  <!-- Footer Buttons -->
  <!-- <div class="notify">
    <button class="button buttonBlue" type="button" (click)="onSubmit()">
      Save Invoice
    </button>
  </div> -->
  <!-- [class.spinner]="loading"
      [disabled]="loading" -->
  <div class="col-md-7">
    <button
      type="submit"
      class="button buttonBlue"
      (click)="onSubmit()"
    >
      Submit
    </button>
  </div>
</form>